function checkSingleOption(optionNumber, possibleVariants, wrapper) {
    const availableOptions = [...new Set(possibleVariants.map(item => item[`option${optionNumber}`]))];
    const curentItems = [...new Set(Array.from(document.querySelectorAll(`[data-option-position='${optionNumber}']`)).map(item => item.value))]
    const hideElements = (curentItems.filter(item => !availableOptions.includes(item)))
    curentItems?.forEach(item => {
        wrapper.querySelector(`[value='${item}']`).parentNode.style.display = 'block';
    });
    hideElements?.forEach(item => {
        wrapper.querySelector(`[value='${item}']`).parentNode.style.display = 'none';
    });

}

function checkOptions(possibleVariants, seletecOption, wrapper) {
    if (seletecOption == 1) {
        checkSingleOption(2, possibleVariants, wrapper)
        checkSingleOption(3, possibleVariants, wrapper)
    } else if (seletecOption == 2) {
        checkSingleOption(3, possibleVariants, wrapper)
    }
}


document.addEventListener('teeinblue-event-component-injected', async function () {
    setTimeout(async function () {
        const elem = document.querySelector(".custom-product-option-tab")
        document.querySelector("#teeFormInputs").appendChild(elem)
        elem.style.display = "block";
    }, 200)
});




document.addEventListener('DOMContentLoaded', async function () {
    let euro = Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
    });

    const data = await fetch(`${window.location.pathname}.json`).then(data => data.json())
    document.querySelectorAll(".option-group input[type='radio']").forEach(radio => {
        radio.addEventListener("change", function (e) {
            const optionId = `option${e.target.dataset.optionPosition}`;
            const value = e.target.value;

            const variants = data.product.variants.filter(item => {
                if (e.target.dataset.optionPosition == 1) {
                    return item[optionId] == value
                } else if (e.target.dataset.optionPosition == 2) {
                    return item.option1 == e.target.closest(".product-swatch").querySelector("[data-option-position='1']:checked").value && item[optionId] == value
                }
            });

            console.log(variants);
            checkOptions(variants, e.target.dataset.optionPosition, e.target.closest(".product-swatch"));
        });
    });

    document.addEventListener("teeinblue-event-variant-changed", function (e) {
        console.log(e.detail.variantId, data);
        const variant = data.product.variants.find(variant => variant.id == e.detail.variantId);
        console.log(parseFloat(variant.price));
        document.querySelectorAll(".tab-link").forEach((item, index) => {
            const priceElem = item.querySelector(".price");
            const savingElem = item.querySelector(".saving-amount");
            if (index == 0) {
                priceElem.innerHTML = euro.format(variant.price);
            } else {
                // AU and CA are consolidated to one pair -- 10% for two, 20% for three --
                // matching discount_two_products / discount_three_products in their own
                // templates/product.json. 0.9 = pay 90% = 10% off, 0.8 = pay 80% = 20% off.
                var discount = (index == 1) ? 0.9 : 0.8;
                var discountedPrice = variant.price * discount;
                var saving = variant.price - discountedPrice;
                savingElem.innerHTML = euro.format(saving * (index + 1));
                priceElem.innerHTML = `Nur ${euro.format(discountedPrice * (index + 1))}`;
            }
        })

    });

    const tabLinks = document.querySelectorAll('.tab-link');
    const tabContents = document.querySelectorAll('.tab-content');

    tabLinks.forEach(function (tabLink) {
        tabLink.addEventListener('click', function () {
            const tabId = this.getAttribute('data-tab');

            tabLinks.forEach(function (link) {
                link.classList.remove('current');
            });

            tabContents.forEach(function (content) {
                content.classList.remove('current');
            });

            this.classList.add('current');
            document.getElementById(tabId).classList.add('current');
            const quantity = parseInt(tabId.replace("tab-", ""));
            const quantityEl = document.querySelector('.tee-quantity [name="quantity"]');

            if (quantity && quantityEl) {
                quantityEl.value = quantity;
                quantityEl.dispatchEvent(new Event('input'));
            }

        });
    });
});
